import { takeEvery, put, call, all } from "redux-saga/effects";
//import actionType
import {
  GET_MASTER_COMPANY_USAGE_STATS,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID,
  GET_COMPANY_LIST,
  GET_COMPANY_BY_ID,
  GET_COMPANY_RECENT_ACTIVITY_LIST,
  MASTER_INVOICE_SEARCH,
  MASTER_INVOICE_PDF,
  MASTER_SYSTEM_ERROR_LOG_LIST,
  MASTER_SYSTEM_ERROR_LOG_DATA,
  MASTER_SYSTEM_ERROR_LOG_SEARCH,
  GET_MASTER_USER_LIST,
  GET_MASTER_RECENT_ACTIVITY_LIST,
} from "./actionType";
//import action
import {
  getMasterCompanyUsageStatsSuccess,
  getMasterCompanyUsageStatsFailed,
  getMasterCompanyUsageStatsByIdSuccess,
  getMasterCompanyUsageStatsByIdFailed,
  getCompanyListSuccess,
  getCompanyListFailed,
  getCompanyByIdSuccess,
  getCompanyByIdFailed,
  getCompanyRecentActivityListSuccess,
  getCompanyRecentActivityListFailed,
  masterInvoiceSearchSuccess,
  masterInvoiceSearchFailed,
  masterInvoicePdfSuccess,
  masterInvoicePdfFailed,
  masterSystemErrorLogListSuccess,
  masterSystemErrorLogListFailed,
  masterSystemErrorLogDataSuccess,
  masterSystemErrorLogDataFailed,
  masterSystemErrorLogSearchSuccess,
  masterSystemErrorLogSearchFailed,
  getMasterUserListSuccess,
  getMasterUserListFailed,
  getMasterRecentActivityListSuccess,
  getMasterRecentActivityListFailed,
} from "./action";

//import api fakeBackendData
import {
  getMasterCompanyUsageStatsApi,
  getMasterCompanyUsageStatsByIdApi,
  getCompanyListApi,
  getCompanyByIdApi,
  getCompanyRecentActivityListApi,
  masterInvoiceSearchApi,
  masterInvoicePdfApi,
  masterSystemErrorLogListApi,
  masterSystemErrorLogDataApi,
  masterSystemErrorLogSearchApi,
  masterUserListApi,
  masterRecentActivityListApi,
} from "../../helpers/fakebackend_helper";

// saga

export function* getMasterCompanyUsageStatsSaga() {
  try {
    const data = yield call(getMasterCompanyUsageStatsApi);
    yield put(getMasterCompanyUsageStatsSuccess(data));
  } catch (error) {
    yield put(getMasterCompanyUsageStatsFailed(error));
  }
}

export function* getMasterCompanyUsageStatsByIdSaga(action) {
  try {
    const data = yield call(getMasterCompanyUsageStatsByIdApi, action.id);
    yield put(getMasterCompanyUsageStatsByIdSuccess(data));
  } catch (error) {
    yield put(getMasterCompanyUsageStatsByIdFailed(error));
  }
}

export function* getCompanyListSaga() {
  try {
    const data = yield call(getCompanyListApi);
    yield put(getCompanyListSuccess(data));
  } catch (error) {
    yield put(getCompanyListFailed(error));
  }
}

export function* getCompanyByIdSaga(action) {
  try {
    const data = yield call(getCompanyByIdApi, action.id);
    yield put(getCompanyByIdSuccess(data));
  } catch (error) {
    yield put(getCompanyByIdFailed(error));
  }
}

export function* getCompanyRecentActivityListSaga(action) {
  try {
    const data = yield call(getCompanyRecentActivityListApi, action.payload);
    yield put(getCompanyRecentActivityListSuccess(data));
  } catch (error) {
    yield put(getCompanyRecentActivityListFailed(error));
  }
}

export function* masterInvoiceSearchSaga(action) {
  try {
    const data = yield call(masterInvoiceSearchApi, action.payload);
    yield put(masterInvoiceSearchSuccess(data));
  } catch (error) {
    yield put(masterInvoiceSearchFailed(error));
  }
}

export function* masterInvoicePdfSaga(action) {
  try {
    const data = yield call(masterInvoicePdfApi, action.payload);
    yield put(masterInvoicePdfSuccess(data));
  } catch (error) {
    yield put(masterInvoicePdfFailed(error));
  }
}

export function* masterSystemErrorLogListSaga() {
  try {
    const data = yield call(masterSystemErrorLogListApi);
    yield put(masterSystemErrorLogListSuccess(data));
  } catch (error) {
    yield put(masterSystemErrorLogListFailed(error));
  }
}

export function* masterSystemErrorLogDataSaga(action) {
  try {
    const data = yield call(masterSystemErrorLogDataApi, action.payload);
    yield put(masterSystemErrorLogDataSuccess(data));
  } catch (error) {
    yield put(masterSystemErrorLogDataFailed(error));
  }
}

export function* masterSystemErrorLogSearchSaga(action) {
  try {
    const data = yield call(masterSystemErrorLogSearchApi, action.payload);
    yield put(masterSystemErrorLogSearchSuccess(data));
  } catch (error) {
    yield put(masterSystemErrorLogSearchFailed(error));
  }
}

export function* getMasterUserListSaga() {
  try {
    const data = yield call(masterUserListApi);
    yield put(getMasterUserListSuccess(data));
  } catch (error) {
    yield put(getMasterUserListFailed(error));
  }
}

export function* getMasterRecentActivityListSaga() {
  try {
    const data = yield call(masterRecentActivityListApi);
    yield put(getMasterRecentActivityListSuccess(data));
  } catch (error) {
    yield put(getMasterRecentActivityListFailed(error));
  }
}

//watcher
export function* watchGetMasterCompanyUsageStatsSaga() {
  yield takeEvery(
    GET_MASTER_COMPANY_USAGE_STATS,
    getMasterCompanyUsageStatsSaga
  );
}
export function* watchGetMasterCompanyUsageStatsByIdSaga() {
  yield takeEvery(
    GET_MASTER_COMPANY_USAGE_STATS_BY_ID,
    getMasterCompanyUsageStatsByIdSaga
  );
}
export function* watchGetCompanyListSaga() {
  yield takeEvery(GET_COMPANY_LIST, getCompanyListSaga);
}
export function* watchGetCompanyByIdSaga() {
  yield takeEvery(GET_COMPANY_BY_ID, getCompanyByIdSaga);
}
export function* watchGetCompanyRecentActivityListSaga() {
  yield takeEvery(
    GET_COMPANY_RECENT_ACTIVITY_LIST,
    getCompanyRecentActivityListSaga
  );
}
export function* watchMasterInvoiceSearchSaga() {
  yield takeEvery(MASTER_INVOICE_SEARCH, masterInvoiceSearchSaga);
}

export function* watchMasterInvoicePdfSaga() {
  yield takeEvery(MASTER_INVOICE_PDF, masterInvoicePdfSaga);
}

export function* watchMasterSystemErrorLogListSaga() {
  yield takeEvery(MASTER_SYSTEM_ERROR_LOG_LIST, masterSystemErrorLogListSaga);
}

export function* watchMasterSystemErrorLogDataSaga() {
  yield takeEvery(MASTER_SYSTEM_ERROR_LOG_DATA, masterSystemErrorLogDataSaga);
}

export function* watchMasterSystemErrorLogSearchSaga() {
  yield takeEvery(
    MASTER_SYSTEM_ERROR_LOG_SEARCH,
    masterSystemErrorLogSearchSaga
  );
}

export function* watchGetMasterUserListSaga() {
  yield takeEvery(GET_MASTER_USER_LIST, getMasterUserListSaga);
}

export function* watchGetMasterRecentActivityListSaga() {
  yield takeEvery(
    GET_MASTER_RECENT_ACTIVITY_LIST,
    getMasterRecentActivityListSaga
  );
}

//export saga
export default function* BackendAdmin() {
  yield all([
    watchGetMasterCompanyUsageStatsSaga(),
    watchGetMasterCompanyUsageStatsByIdSaga(),
    watchGetCompanyListSaga(),
    watchGetCompanyByIdSaga(),
    watchGetCompanyRecentActivityListSaga(),
    watchMasterInvoiceSearchSaga(),
    watchMasterInvoicePdfSaga(),
    watchMasterSystemErrorLogListSaga(),
    watchMasterSystemErrorLogDataSaga(),
    watchMasterSystemErrorLogSearchSaga(),
    watchGetMasterUserListSaga(),
    watchGetMasterRecentActivityListSaga(),
  ]);
}
